import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FileUploader } from 'react-drag-drop-files';
import { LuUpload } from 'react-icons/lu';
import pdfToText from "react-pdftotext";
import { getPdfData } from '../../containers/User/Dashboard/actions';

export default function MyVesselUploadPDFModal(props) {
    const { handleClose, title = "Import Vessel Details from PDF", setQuery, query, open } = props;
    const [error, setError] = useState("");
    const [fileUploading, setFileUploading] = useState("");



    const fileTypes = ["PDF"];
    const handleChange = async (file) => {
        setFileUploading("Pdf file Uploading...");
        const queryid = await pdfToText(file)
            .then((text) => {
                const startIndex = text.indexOf("myVesselpdfId:");
                const endIndex = text.indexOf("#", startIndex);
                if (startIndex !== -1 && endIndex !== -1) {
                    let substring = text.substring(startIndex + "myVesselpdfId:".length, endIndex);
                    substring = substring.replace(/\s+/g, "");
                    return substring;
                }
                return "";
            }).catch(() => setError("invalid file! Please upload valid file"));
        if (!queryid) {
            setError("invalid file! Please upload valid file")
            return
        } else {
            setError("")
        }
        try {

            const details = await getPdfData(queryid)
            if (details?.success) {
                setQuery({ ...query, ...details.data })

                setFileUploading("File Uploaded Successfully!")
            } else {
                setError("invalid file! Please upload valid file")
            }
        } catch (err) {
            setError("Something went wrong!")
        }
    };
    const CustomSection = () => {
        return (
            <div className="upload-container" id="drop-area">
                <LuUpload size={18} aria-hidden="true" />
                <span className="upload-container-title">Choose a PDF or drag it here</span>
                {!error && <p aria-live="polite">{fileUploading || "PDF files only"}</p>}
                {error && <p className="!text-rose-600" role="alert">{error}</p>}
            </div>
        )
    }
    const onClose = () => {
        handleClose()
        setError("")
        setFileUploading("")
    }
    return (
        <div>
            <Dialog
                open={open}
                fullWidth
                maxWidth="sm"
                onClose={() => onClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" className="font-family">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText component="div" id="alert-dialog-description" className="font-family">
                        <FileUploader classes="pdf-upload-trigger" dropMessageStyle={{ color: "#000", backgroundColor: 'red' }} children={<CustomSection />} multiple={false} handleChange={handleChange} name="file" label="Upload or drop a file right here" types={fileTypes} />
                    </DialogContentText>
                    <div className="mt-3 border border-slate-200 bg-slate-50 px-3 py-2 text-[12px] text-slate-700">
                        <div className="font-semibold text-slate-900 mb-1">Where to get the PDF</div>
                        In Vessel Manager, go to My Vessel &gt; Vessel List. Open a saved vessel and choose Download PDF in its details. Upload that downloaded PDF here.
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => onClose()} color="primary" className="font-family" autoFocus>
                        {fileUploading ? "Confirm" : "Cancel"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
